import http from '@/utils/http'
import { networkData } from '@/utils/data'

//二维码
export const getQRCodeList = (params) => http.get(`/marking-platform/task/regions/${params.schoolId}/types/REGION_STUDENT_QR`, params)//生成二维码列表
export const generateQRCode = (params) => http.post(`/marking-platform/task/student-qr/regions/${params.regionId}/grade-num/${params.gradeNum}/qr-types/${params.type}`, params.schoolIds)//生成二维码
export const deleteQRCode = (id) => http.delete('/marking-platform/task/' + id, {})//删除二维码
export const reGenerateQRCode = (params) => http.post(`/marking-platform/task/${params.qcId}/student-qr/regions`, {}) //重新生成二维码
export const updateQRCodeDownload = (id) => http.put(`/marking-platform/task/region/code-task/${id}`, {}) // 更新二维码下载状态
export const getQRCodeNum = (params) => http.get(`/marking-platform/task/schools/${params.schoolId}/types/REGION_STUDENT_QR/count`, {})//获取带下载二维码数量

//学校管理
export const queryClass = gradeId => http.get('/marking-platform/school-class/grade-class/gradeId/' + gradeId, {})
export const queryGrade = (params) => http.get('/marking-platform/school/grade/school-id/academic-year', params)
export const getSchool = schoolId => http.post('marking-platform/school/' + schoolId, {})
export const getSchoolList = (params) => http.postXkw('/marking-platform/regions/schools/search/relation-schools', params)//获取学校列表
export const getGroupList = (params) => http.get('/marking-platform/regions/schools/groups', params)//获取分组列表
export const moveToGroup = (params) => http.put('/marking-platform/regions/schools/groups/move', params)//获取分组列表

//学生管理
export const addCodeTask = (params) => http.post('/marking-platform/task', params)//新增二维码考务
export const listCodeTask = (params) => http.get(`/marking-platform/task/regions/${params.regionId}/types/REGION_EXAM_TASK_STUDENT_QR`, params)//查询二维码考务
export const downloadSchoolCode = (id) => http.put('/marking-platform/task/region/sub-code-task/' + id, {})//下载考务学校二维码
export const genSchoolCode = (params) => http.post(`/marking-platform/task/region/code-task/${params.codeTaskId}/schools/${params.schoolId}`, {})//生成考务学校二维码
export const genTaskCode = (id) => http.post('/marking-platform/task/region/code-task/' + id, {})//生成考务二维码
export const getCodeTask = (id) => http.get('/marking-platform/task/' + id, {})//查询二维码考务任务
export const delCodeTask = (id) => http.delete('/marking-platform/task/' + id, {})// 删除二维码考务任务
export const listStudentUploadFile = (params) => http.post('/marking-user/user/student/list_student_upload_file', params)//上传学生

export const delStudent = (params) => http.post('/marking-user/user/student/del_stu', params, 'form') //删除学生
export const phaseGetSubject = (params) => http.post('/marking-user/user/ability/get_subject', params)//根据学段获取学科
export const getAbility = (params) => http.post('/marking-user/user/ability/get_list', params)//根据学科获取能力
export const addAbility = (params) => http.post('/marking-user/user/ability/insert', params)//添加能力
export const delAbility = (params) => http.post('/marking-user/user/ability/delete', params)//删除能力
export const getRegionRatioSchoolList = (params) => http.get('/marking-platform/school-class/list_choose_group_school_class', params).then(resp => {
  if (resp.code === 0) {
    return { code: 200, result: resp.body || [] }
  } else {
    return resp
  }
})	// 抽测根据比例获取学校和班级
export const getRegionGroupSchoolList = (params) => http.get('/marking-platform/school-class/list_group_school_class', params, 'form')	// 抽测手动获取区域下所有学校与班级

export const getRegionSchools = (regionId) => http.get('/marking-platform/school/regionId', { regionId })	// 获取区域下所有学校列表

export const configApi = {
  // 根据学校，学段获取科目
  getStageSubjects: (schoolId, stage) => http.get(`/marking-platform/configurations/schools/${schoolId}/stages/${stage}/subjects`),
  // 根据学校，年级获取科目
  getGradeSubjects: params => http.post(`/marking-platform/configurations/schools/subjects/list`, params),
  // 获取其他配置
  getOther: (schoolId) => http.get(`/marking-platform/configurations/schools/${schoolId}/platformTypes/REGION/others`).then(resp => {
    setConfigOptions(resp)
    return resp
  }),
  // 更新参数数值
  update: params => http.put(`/marking-platform/configurations/values`, params),
  getRegionStages: schoolId => http.get(`/marking-platform/configurations/regions/${schoolId}/stages`),
  // 获取区域高频错题，薄弱知识配置
  getRegionWeakKnp: (schoolId, stage) =>  http.post('/marking-platform/configurations/getByParam', {
    schoolId,
    stage,
    configGroup: "EXAM_WEAK"
  }),
  // 根据学校，年级获取科目下面得分等级
  getSchoolLevels: (schoolId, grade, courseId) => http.get(`/marking-platform/configurations/schools/${schoolId}/grades/${grade}/values?courseId=${courseId}`),
  // 初始化学校的配置
  initSchool: schoolId => http.post(`/marking-platform/configurations/schools/${schoolId}`),
  // 获取统计配置
  getStatistics: schoolId => http.post('/marking-platform/configurations/getByParam', { schoolId, configGroup: "EXAM_ANALYSE" }).then(resp => {
    setConfigOptions(resp)
    return resp
  }),
  // 根据类型列表获取配置详情
  getConfigByTypes: (schoolId, types) => http.post(`/marking-platform/configurations/schools/${schoolId}/configTypes`, types).then(resp => {
    setConfigOptions(resp)
    return resp
  }),
}

export const getSubjectList = (params, isFilter = false) => {
  // 新接口数据，转换成 旧接口的数据格式
  return configApi.getGradeSubjects(params).then(resp => {
    if (resp.body) {
      return networkData.getTodoSubjects(resp.body, isFilter)
    }
    return resp
  })
}

export const getSubject = (params) => {
  params.gradeId = params.dicId
  // 新接口数据，转换成 旧接口的数据格式
  return configApi.getGradeSubjects(params).then(resp => {
    if (resp.body) {
      for (let index = 0; index < resp.body.length; index++) {
        const element = resp.body[index];
        element.dicCode = element.id
        element.dicName = element.shortName
      }
    }
    return resp
  })
}


function setConfigOptions (resp) {
  for (let index = 0; index < resp.body.length; index++) {
    const item = resp.body[index];
    item.configDescOptions = []
    const desc = item.configTypeDesc ? item.configTypeDesc : ''
    if (desc && desc.indexOf('$') === -1) continue
    // 配置规则的选项解析
    const list = desc.split('$')
    for (let cIndex = 0; cIndex < list.length; cIndex++) {
      const element = list[cIndex];
      const infos = element.split('-')
      if (infos.length <= 1) continue
      item.configDescOptions.push({
        name: infos[1],
        value: infos[0]
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/api/system.js